import styled from 'styled-components';
import { animated } from 'react-spring';
import { Close } from 'styled-icons/material/Close';

const getColor = (props) => {
  if (props.isDragAccept) {
    return '#00e676';
  }
  if (props.isDragReject) {
    return '#ff1744';
  }
  if (props.isDragActive) {
    return '#0D9B9E';
  }
  return '#eee';
};

export const Upload = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  h3 {
    font-size: ${(props) => props.compact ? '1.2rem' : '1.4rem'};
    line-height: ${(props) => props.compact ? '18px' : '21px'};
    color: ${(props) => props.theme.colors.UploadSurveyTitleColor};
    font-weight: 400;
    margin-bottom: ${(props) => props.compact ? '4px' : '8px'};
  }

  p {
    font-size: ${(props) => props.compact ? '1.2rem' : '1.4rem'};
    color: ${(props) => props.theme.simulation.staticTextColor};
    font-weight: 400;

    span {
      color: #00c6c9;
    }
  }
`;

export const ListFiles = styled(animated.div)`
  width: 100%;
`;

export const File = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid ${(props) => props.hasError ? props.theme.colors.statusError : props.theme.colors.UploadSurveyTitleColor};
  background-color: ${(props) => props.hasError ? 'transparent' : props.theme.colors.normalButtonBackgroundColor};
  width: 100%;
  padding: 12px 24px;
  border-radius: 8px;
  position: relative;

  .info {
    h4 {
      font-weight: 400;
      color: ${(props) => props.theme.colors.UploadSurveyTitleColor};
      margin-bottom: 4px;
      font-size: 1.2rem;
    }

    span {
      font-weight: 400;
      color: #A1B4C4;
      font-size: 1.2rem;
    }
  }

  .action .wrapperImage {
    background-color: #8e8e8e;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  /* design de progresso => deve receber via props a porcentagem e adicionar ao width */
  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba(97, 0, 129, 0.1);
    width: ${(props) => props.progress}%;
    height: 100%;
  }
`;

export const DragDrop = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: ${(props) => props.compact ? '16px 16px' : '32px 16px'};
  cursor: copy;
  border-width: 1px;
  border-style: dashed;
  border-radius: 4px;
  border-color: ${(props) => getColor(props)};
  transition: border-color 0.2s linear;
  &:focus,
  &:hover {
    border: 1px dashed #0D9B9E;
  }
`;

export const Image = styled.div`
  align-self: center;
  margin-bottom: ${(props) => props.compact ? '12px' : '24px'};

  img {
    width: ${(props) => props.compact ? '32px' : 'auto'};
    height: ${(props) => props.compact ? '32px' : 'auto'};
  }
`;

export const CloseButton = styled(Close)`
`;

export const ReplaceFileWrapper = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
`;

export const ReplaceFileText = styled.span`
  color: #0D9B9E;
  font-size: 12px;
  margin: 0;
  padding: 0;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-decoration-line: underline;
`;